<template>
  <div class="main-page page-listone">
    <Menu
      title="执法信息查询"
      :home="true"
    />
    <div class="container-flex wrap-list">
      <div class="right-con">
        <iframe
          id="iframeId"
          :src="url"
          frameborder="0"
          class="iframe"
          scrolling="auto"
        >
        </iframe>

      </div>

    </div>
  </div>
</template>
<script>
import Menu from '../components/Menu'
export default {
  components: {
    Menu
  },
  data () {
    return {
      url: 'https://zfzj.p.laway.cn/bs/zfzj/query'
    }
  }

}
</script>
<style lang="stylus" >
.page-listone
  .hide-terminal
    display none !important
  .wrap-list
    height 100%
    display flex
    justify-content center
    padding 0.09rem 0.6rem 0.5rem
    .right-con
      position relative
      height 100%
      width 12.46rem
      overflow-y scroll
      background #fff
      border-radius 0.1rem
      webkit-overflow-scrolling touch
      box-sizing border-box
      .content
        padding 0 0.9rem
      &::-webkit-scrollbar
        display none
        width 0 !important
      .title
        font-size 0.36rem
        color #333333
        font-weight 600
        padding 0.7rem 0 0.2rem 0
      .detail
        padding 0 0 0.45rem 0
        p
          margin 1em 0 !important
          font-size 0.22rem !important
          line-height 1.6
        span
          font-size 0.22rem !important
          line-height 1.6
        img
          max-width 100%
          display block
          margin 0 auto
      .emptyinfo
        display flex
        flex-direction column
        justify-content center
        align-items center
        width 100%
        font-size 0.22rem
        color #999
        height 100%
        img
          display block
          margin-bottom 0.2rem
    .list-nav
      width 1.7rem
      height 9rem
      margin-left 0.4rem
      display flex
      flex-direction column
      justify-content flex-end
      .item
        height 1.1rem
        background-color #557dff
        border-radius 0.1rem
        color #fff
        font-size 0.22rem
        display flex
        flex-direction column
        justify-content center
        margin-top 0.15rem
        align-items center
        span
          font-weight 600
.iframe
  width 100%
  height 100%
  display flex
  align-items center
  justify-content center
  padding 0.3rem 0 0.3rem 0.3rem
</style>
